module.exports = __webpack_public_path__ + "files/9ac99bfabdbc5a69bf6c08f5a6a8aa12.png";